import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.state == 1 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 0,
    class: "el-icon-success",
    style: {
      "color": "green"
    }
  })) : _createCommentVNode("", true), $props.state == -1 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 1,
    class: "el-icon-error",
    style: {
      "color": "red"
    }
  })) : _createCommentVNode("", true), $props.state == 0 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 2,
    class: "el-icon-question",
    style: {
      "color": "#519eff"
    }
  })) : _createCommentVNode("", true), $props.state == 2 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 3,
    class: "el-icon-warning",
    style: {
      "color": "yellow"
    }
  })) : _createCommentVNode("", true)], 64);
}